/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WallItemCapabilitiesFromJSON(json) {
    return WallItemCapabilitiesFromJSONTyped(json, false);
}
export function WallItemCapabilitiesFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'canSendTrackableTypes': !exists(json, 'can_send_trackable_types') ? undefined : json['can_send_trackable_types'],
        'canReceiveNonUprightCameraImages': !exists(json, 'can_receive_non_upright_camera_images') ? undefined : json['can_receive_non_upright_camera_images'],
        'sendsArScanningRequests': !exists(json, 'sends_ar_scanning_requests') ? undefined : json['sends_ar_scanning_requests'],
        'canReceiveCompressedDataTrackMessages': !exists(json, 'can_receive_compressed_data_track_messages') ? undefined : json['can_receive_compressed_data_track_messages'],
        'supportsLightshowV2': !exists(json, 'supports_lightshow_v2') ? undefined : json['supports_lightshow_v2'],
        'acceptsInsertableStreams': !exists(json, 'accepts_insertable_streams') ? undefined : json['accepts_insertable_streams'],
        'canReceiveVideo': !exists(json, 'can_receive_video') ? undefined : json['can_receive_video'],
        'canSendCameraSubjects': !exists(json, 'can_send_camera_subjects') ? undefined : json['can_send_camera_subjects'],
    };
}
export function WallItemCapabilitiesToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'can_send_trackable_types': value.canSendTrackableTypes,
        'can_receive_non_upright_camera_images': value.canReceiveNonUprightCameraImages,
        'sends_ar_scanning_requests': value.sendsArScanningRequests,
        'can_receive_compressed_data_track_messages': value.canReceiveCompressedDataTrackMessages,
        'supports_lightshow_v2': value.supportsLightshowV2,
        'accepts_insertable_streams': value.acceptsInsertableStreams,
        'can_receive_video': value.canReceiveVideo,
        'can_send_camera_subjects': value.canSendCameraSubjects,
    };
}
/**
* @export
* @enum {string}
*/
export var WallItemCapabilitiesCanSendTrackableTypes;
(function (WallItemCapabilitiesCanSendTrackableTypes) {
    WallItemCapabilitiesCanSendTrackableTypes["FEATUREPOINT"] = "TRACKABLE_TYPE_FEATURE_POINT";
    WallItemCapabilitiesCanSendTrackableTypes["INVALID"] = "TRACKABLE_TYPE_INVALID";
    WallItemCapabilitiesCanSendTrackableTypes["MARKER2D"] = "TRACKABLE_TYPE_MARKER_2D";
    WallItemCapabilitiesCanSendTrackableTypes["MARKER3D"] = "TRACKABLE_TYPE_MARKER_3D";
    WallItemCapabilitiesCanSendTrackableTypes["MESH"] = "TRACKABLE_TYPE_MESH";
    WallItemCapabilitiesCanSendTrackableTypes["PLANE"] = "TRACKABLE_TYPE_PLANE";
    WallItemCapabilitiesCanSendTrackableTypes["STATIC"] = "TRACKABLE_TYPE_STATIC";
})(WallItemCapabilitiesCanSendTrackableTypes || (WallItemCapabilitiesCanSendTrackableTypes = {}));
/**
* @export
* @enum {string}
*/
export var WallItemCapabilitiesCanSendCameraSubjects;
(function (WallItemCapabilitiesCanSendCameraSubjects) {
    WallItemCapabilitiesCanSendCameraSubjects["PERSON"] = "CAMERA_SUBJECT_PERSON";
    WallItemCapabilitiesCanSendCameraSubjects["SCREEN"] = "CAMERA_SUBJECT_SCREEN";
    WallItemCapabilitiesCanSendCameraSubjects["WORLD"] = "CAMERA_SUBJECT_WORLD";
})(WallItemCapabilitiesCanSendCameraSubjects || (WallItemCapabilitiesCanSendCameraSubjects = {}));
//# sourceMappingURL=WallItemCapabilities.js.map